import styled from "styled-components";

// components
import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";

export const Loading = styled.div(({ theme }) => ({
    margin: theme.spacing.medium,
    display: "flex",
    height: theme.spacing.small,
    borderRadius: theme.cornerRadius.xxSmall,
    background: theme.colors[theme.colorMode].background_Secondary,
}));

export const StyledCardContainer = styled(CardContainer)<{ $placement: "top" | "bottom" }>(({ theme, $placement }) => ({
    ...($placement === "top" && {
        marginTop: theme.spacing.medium,
        transform: `translate3d(${theme.spacing.empty}, ${theme.spacing.empty}, ${theme.spacing.small})`,
    }),
    ...($placement === "bottom" && {
        marginTop: `-${theme.spacing.medium}`,
    }),
}));
